/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWorkspaceUserDto } from '../../models/client-workspace-user-dto';
import { PageInfoDto } from '../../models/page-info-dto';

export interface ClientWorkspaceUserControllerSearchOffset$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 사용자 ID
 */
  userId?: string;

/**
 * 고객사 ID
 */
  clientWorkspaceId?: string;

/**
 * 활성 여부
 */
  activeMember?: boolean | null;
}

export function clientWorkspaceUserControllerSearchOffset(http: HttpClient, rootUrl: string, params: ClientWorkspaceUserControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items'?: Array<ClientWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceUserControllerSearchOffset.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('userId', params.userId, {});
    rb.query('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.query('activeMember', params.activeMember, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items'?: Array<ClientWorkspaceUserDto>;
      'pageInfo'?: PageInfoDto;
      }>;
    })
  );
}

clientWorkspaceUserControllerSearchOffset.PATH = '/api/clientWorkspaceUser/search/offset';
